import * as _ from 'underscore';
import { IPlace, ISubplace } from '../models/IPlace';
import { ILeafFilterClause } from '../ServerApi/types/IFilterClause';

export class SubplaceEvents {
  public static Refresh = 'Refresh';
  public static RefreshCounts = 'RefreshCounts';
}

// TODO: Combine the following into a single SubplaceHelper.

export interface ISubplaceTabsScope extends ng.IScope {
  subplaceTabClicked: (name: string) => void;
}

export module SubplaceTabsHelper {

  export function refreshWhenCurrentTabClicked($scope: ISubplaceTabsScope, $state: ng.ui.IStateService) {
    $scope.subplaceTabClicked = (name: string) => {
      const currentTab = $state.includes('**.' + name + '.**');
      if (currentTab) {
        $scope.$broadcast(SubplaceEvents.Refresh);
      } else {
        $scope.$broadcast(SubplaceEvents.RefreshCounts, name);
      }
    };
  }

}

export interface ISubplaceCountsScope extends ng.IScope {
  subplaceCounts: _.Dictionary<number>;
}

export module SubplaceCountsHelper {

  export function updateCountsFromSubplace($scope: ISubplaceCountsScope, subplace: ISubplace<any>, count: number) {
    $scope.subplaceCounts[subplace.name] = count;
  }

  export function keepSubplaceCountsUpdated($scope: ISubplaceCountsScope, place: IPlace) {
    const subplaceFilters: _.Dictionary<ILeafFilterClause[]> = {};
    $scope.subplaceCounts = $scope.subplaceCounts || {};
    const refreshCounts = (force?: boolean) => {
      _.each(place.subplaces(), (subplace: ISubplace<any>) => {
        const name = subplace.name;
        const query = subplace.query();
        const newFilters = query.getFilters();
        if (force || !_.isEqual(newFilters, subplaceFilters[name])) {
          subplaceFilters[name] = newFilters;
          query.getCount().then((count: number) => {
            $scope.subplaceCounts[subplace.name] = count;
          });
        }
      });
    };
    $scope.$on('$locationChangeSuccess', () => {
      refreshCounts();
    });
    $scope.$on(SubplaceEvents.RefreshCounts, () => {
      refreshCounts(true);
    });
    refreshCounts();
  }

}
